<template>
    <div class="skill-badge">
        <p>{{ text }}</p>
    </div>
  </template>
  
  <script>
  export default {
    name: "SkillBadge",
    props: {
      text: {
        type: String,
        required: true,
      },
    },
  };
  </script>
  
  <style scoped>
    .skill-badge {
        background: #00000079;
        -webkit-backdrop-filter: blur(10px);
        backdrop-filter: blur(10px);
        padding: 8px 24px 8px 24px;
        border-radius: 100px;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .skill-badge p {
        margin: 0;
        padding: 0;
        font-size: clamp(10px, 0.83vw, 16px);
    }

    @media screen and (max-width: 535px) {
      .skill-badge {
        padding: 4px 12px 4px 12px;
      }
    }
  </style>
  